import { combineReducers } from "redux";
import userInfoReducer from "./authReducer";
import projectReducer from "./projectReducers";
import defaultSettingsReducer from "./defaultSettingsReducers";
import projectsReducer from "./projectsReducer";
import undoRedoReducer from "./undoRedoReducer";
import fontUndoRedoReducer from "./fontUndoRedoReducer";
import screenUndoRedoReducer from "./screenUndoRedoReducer";
import applicationReducer from "./applicationReducer";
import commonReducer from "./commonReducer";
import HelpingPageReducer from "./HelpingPageReducer";
// CARD Reducers
import CardProjectsReducer from "./cards/CardProjectsReducer";
import CardEditReducer from "./cards/CardEditReducer";
import CardRenderReducer from "./cards/CardRenderReducer";

const reducers = combineReducers({
  userInfo: userInfoReducer,
  project: projectReducer,
  defaultSettings: defaultSettingsReducer,
  projects: projectsReducer,
  undoRedo: undoRedoReducer,
  fontUndoRedo: fontUndoRedoReducer,
  screenUndoRedo: screenUndoRedoReducer,
  application: applicationReducer,
  commonReducer:commonReducer,
  HelpingPageReducer:HelpingPageReducer,
  // cardProjectsReducer:CardProjectsReducer,
  // CardEditOption:CardEditReducer,
  // cardRenders:CardRenderReducer,
});

export default reducers;
